/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type S3Slide = {
    /**
     * original filename of the slide from the scanner
     */
    name?: string | null;
    readonly id?: number;
    readonly lab_id?: number;
    /**
     * unique identifier for the slide
     */
    readonly uuid?: string;
    /**
     * name of the file stored in S3 generated by the host scanner
     */
    readonly url_path?: string | null;
    /**
     * an md5 hash of the uplaoded s3 filename
     */
    readonly uploader_hash?: string | null;
    readonly created_at?: string;
    /**
     * the name of the process that added the slide
     */
    inserted_by?: S3Slide.inserted_by;
    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    status?: S3Slide.status;
}

export namespace S3Slide {

    /**
     * the name of the process that added the slide
     */
    export enum inserted_by {
        UPLOADER = 'uploader',
        WPL_IMPORT = 'WPL Import',
        SONIC_IMPORT = 'Sonic Import',
        SCAN_AND_IMPORT_SLIDES = 'scan_and_import_slides',
        WSI_IMPORTER_SCRIPT = 'wsi_importer_script',
        LIS_IMPORT = 'LIS Import',
        SEED_COMMAND = 'Seed Command',
    }

    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    export enum status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
    }


}
